angular.module('TetherApp').factory('fulfilmentBatchService', [
    '$http',
    function ($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let batchableExperiences = function() {
            let uri = '/api/v1/experiences/batchable/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );

        }

        return {
            batchableExperiences: batchableExperiences
        }
    }
]);
